import { ENV_DEV } from 'src/constants/environments';
import type { Environment } from 'src/types';

const isMetricsEnabled = (environment: Environment) => environment !== ENV_DEV;

export default isMetricsEnabled;
